import { render, staticRenderFns } from "./ChatMiddleTransfer.vue?vue&type=template&id=738d86ac&"
import script from "./ChatMiddleTransfer.vue?vue&type=script&lang=js&"
export * from "./ChatMiddleTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ChatMiddleTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports